import { createPortal } from "react-dom";

const DarkLoadingSpinner = () => {
  return createPortal(
      <div
        className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center bg-light"
        style={{ zIndex: 999_999_999, opacity: 0.6, margin: 0, left: 0, right: 0 }}
      >
        <div
          className="spinner-border text-dark"
          style={{ width: '3rem', height: '3rem' }}
          role="status"
        >
          <span className="visually-hidden">Loading...</span>
        </div>
        <div
          className="mt-3 text-dark fw-semibold"
          style={{ padding: '0 10px' }}
        >
          Loading...
        </div>
      </div>,
      document.body
    );
}

export default DarkLoadingSpinner